import { Backdrop, NotificationText, Typography } from '@room-match/shared-ui-components';
import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import { talentService } from 'shared/services/talentService';
import { Content, FlexContainer, MainCont, ResetButton, SaveButton } from './Biography.styles';
import { useBiographyForm } from './BiographyForm';
import { convertContent } from 'shared/utils/convertContent';
import { RichEditor } from 'components/RichEditor';

const { getBiography, updateTalent } = talentService();

const Biography = () => {
  const { data, isLoading } = getBiography();
  const { mutateAsync, isLoading: isLoadingUpdate } = updateTalent();
  const queryClient = useQueryClient();
  const [show, setShow] = useState<boolean>(false);
  const [oldEditorState, setOldEditorState] = useState(() => {
    return convertContent('');
  });
  const [editorState, setEditorState] = useState(() => {
    return convertContent('');
  });

  const handleSubmit = async (values: ITalentUpdatePayload) => {
    mutateAsync(
      { biography: values.biography },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['talents/biography'], {
            refetchInactive: true,
          });
          setShow(true);
        },
      },
    );
  };

  const { form } = useBiographyForm({
    onSubmit: handleSubmit,
    data: data?.data,
  });

  const handleContentChange = (content: string) => {
    form.setFieldValue('biography', content);
  };

  useEffect(() => {
    if (data) {
      if (data.data.attributes.biography) {
        setEditorState(convertContent(data.data.attributes.biography || ''));
        setOldEditorState(convertContent(data.data.attributes.biography || ''));
      }
    }
  }, [data]);

  const handleReset = () => {
    setEditorState(oldEditorState);
  };

  return (
    <MainCont>
      <p style={{ fontSize: 15 }}>Biography</p>
      <p style={{ marginTop: 5, fontSize: 15 }}>
        If you don't have a Resume, please enter a quick biography below to tell casting directors / client a little
        about yourself.
      </p>
      <Content>
        <FlexContainer style={{ marginBottom: 15 }}>
          <p style={{ fontSize: 15 }}>Your Biography</p>
          <FlexContainer style={{ marginLeft: 'auto' }} gap={10}>
            <ResetButton
              variant="contained"
              color="secondary"
              disabled={!form.dirty || editorState === oldEditorState}
              onClick={() => handleReset()}
            >
              Reset Changes
            </ResetButton>
          </FlexContainer>
        </FlexContainer>
        <RichEditor
          editorState={editorState}
          setEditorState={setEditorState}
          onChange={handleContentChange}
          minHeight={300}
          isToolbarShow={true}
        />
      </Content>
      <FlexContainer gap={20}>
        <SaveButton
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => {
            form.handleSubmit();
          }}
          disabled={!form.dirty || editorState === oldEditorState}
        >
          Save Changes
        </SaveButton>
        <NotificationText show={show} setShow={setShow} />
      </FlexContainer>
      <Backdrop isLoading={isLoading ? isLoading : isLoadingUpdate ? isLoadingUpdate : false} />
    </MainCont>
  );
};

export default Biography;
